module.exports = __webpack_public_path__ + "static/media/emoji_grinning_face.494245d9.svg";